const { convertArrayToCSV } = require('convert-array-to-csv');
import exportProjectNameMapper from './ExportProjectNameMapper'

const TRANSCRIPT_HEADER = 'Transcript';
const UNTITLED_TRANSCRIPT = 'Untitled Transcript';

// Rows are transcripts, columns are descriptors, cells are the selected
// option names. Selections come from /api/projects/:id/selections/batch.
const exportTranscriptsVDescriptorMapper = (projectData, transcripts, descriptorsData, selectionsData) => {
  const { exportFileName } = exportProjectNameMapper(projectData, 'TranscriptXDescriptor')
  const descriptorArray = Array.isArray(descriptorsData) ? descriptorsData : (descriptorsData?.descriptors || []);
  const selectionsByTranscript = selectionsData?.selections_by_transcript || {};

  const header = [TRANSCRIPT_HEADER, ...descriptorArray.map((descriptor) => descriptor.name)];

  const rows = (transcripts || []).map((transcript) => {
    const transcriptSelections = selectionsByTranscript[transcript.id] || [];
    const choices = descriptorArray.map((descriptor) => {
      const selection = transcriptSelections.find((s) => s.multi_choice_descriptor_id === descriptor.id);
      return selection?.choice || '';
    });
    const name = transcript.name && transcript.name.trim() !== '' ? transcript.name : UNTITLED_TRANSCRIPT;
    return [name, ...choices];
  }).sort((a, b) => a[0].toLowerCase().localeCompare(b[0].toLowerCase()));

  return {
    projectName: exportFileName,
    transcriptsText: convertArrayToCSV(rows, {
      separator: ',',
      header: header
    })
  }
}

export default exportTranscriptsVDescriptorMapper
